import { AxiosError } from 'axios';
import instance from '../config/axios';

export const deleteShipment = async (accessToken: string, orderId: number) => {
  try {
    const response = await instance({
      method: 'DELETE',
      url: `/api/v1/order/shipment/${orderId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log((e as AxiosError).response);
    return (e as AxiosError).response?.status;
  }
};
